// extracted by mini-css-extract-plugin
export default {"wrapper":"W9S9X","base":"r2mpp","imageWrapper":"WtWCp","heading":"Wt48S","description":"LMd_u","button":"z98zk"};